export default "__VITE_ASSET__DyTSBIM0__"